import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import useTelegram from '../../hooks/useTelegram';
import loginApi from '../../api/loginApi';

export default function AuthAutoGate({ onSuccess, onFail }) {
    const { tg } = useTelegram();
    const [state, setState] = useState({ status: 'idle', error: '' });
    const triedInitData = useRef(new Set());
    const cancelledRef = useRef(false);

    // Telegram готов
    useEffect(() => {
        try { window.Telegram?.WebApp?.ready?.(); } catch {}
        try { tg?.expand?.(); } catch {}
    }, [tg]);

    // Получаем initData
    const initData = useMemo(() => {
        const v =
            (tg && tg.initData) ||
            (typeof window !== 'undefined' &&
                window.Telegram &&
                window.Telegram.WebApp &&
                window.Telegram.WebApp.initData) ||
            '';
        return v || '';
    }, [tg]);

    const authenticate = useCallback(async () => {
        if (!initData) {
            setState({ status: 'error', error: 'initData отсутствует. Откройте мини-апп из Telegram.' });
            onFail && onFail(new Error('NO_INIT_DATA'));
            return;
        }

        if (triedInitData.current.has(initData)) return;
        triedInitData.current.add(initData);

        setState({ status: 'authenticating', error: '' });

        try {
            await loginApi.telegramInit(initData);
            const me = await loginApi.me();

            if (!cancelledRef.current) {
                setState({ status: 'success', error: '' });
                onSuccess && onSuccess(me.user || me);
            }
        } catch (e) {
            if (!cancelledRef.current) {
                const msg =
                    (e?.response?.data?.message && String(e.response.data.message)) ||
                    (e?.message && String(e.message)) ||
                    'Авторизация не удалась';
                setState({ status: 'error', error: msg });
                onFail && onFail(e);
            }
        }
    }, [initData, onSuccess, onFail]);

    // авто-вход при монтировании
    useEffect(() => {
        cancelledRef.current = false;
        authenticate();
        return () => { cancelledRef.current = true; };
    }, [authenticate]);

    return (
        <div className="w-full h-dvh min-h-[100svh] bg-black text-white flex items-center justify-center">
            <div className="w-full max-w-md mx-6">
                <div className="bg-white/10 border border-white/15 rounded-2xl p-6">
                    <div className="mb-4">
                        <div className="text-lg font-semibold">Вход через Telegram</div>
                        <div className="text-sm text-white/70">
                            {state.status === 'idle' && 'Готово к авторизации…'}
                            {state.status === 'authenticating' && 'Авторизация…'}
                            {state.status === 'success' && 'Успешно! Переходим…'}
                            {state.status === 'error' && 'Ошибка авторизации'}
                        </div>
                    </div>

                    {state.status === 'error' && (
                        <div className="rounded-lg border border-red-400/30 bg-red-400/10 p-3 text-sm text-red-200 mb-4 break-all">
                            {state.error}
                        </div>
                    )}

                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            onClick={authenticate}
                            className="px-4 py-2 rounded-md bg-white text-black text-sm font-medium"
                        >
                            Повторить вход
                        </button>

                        {!initData && (
                            <div className="text-xs text-white/60">
                                Откройте мини-апп из Telegram, чтобы получить initData.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
